import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03d6d155")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_add_target = _resolveDirective("add-target")!

  return _withDirectives((_openBlock(), _createBlock("article", {
    class: "markdown-display",
    innerHTML: _ctx.html
  }, null, 8, ["innerHTML"])), [
    [_directive_add_target, '_blank']
  ])
})